import { createSignal } from "solid-js";

/**
 * @typedef {object} OverlayState
 * @property {() => void} open Show the overlay
 * @property {() => void} close Hide the overlay
 * @property {() => boolean} isOpen Whether the overlay is currently shown
 */

/**
 * Builds the open/closed state for an app-level overlay. The signal is created
 * outside any component, so callers can drive the overlay from anywhere,
 * including plain modules and keybinding handlers.
 * @returns {OverlayState} The overlay's state and controls
 */
export function createOverlayState() {
  const [isOpen, setIsOpen] = createSignal(false);

  return {
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    isOpen,
  };
}
